import React from 'react'
import './styles.css'
export default function Sent() {
  return (
    <div className='box-sent'>Enviado!</div>
  )
}
